import { TranslatableEntity } from '~/app/core/models/translatable-entity';
import { Tag } from '../../feed/feed-tag/models/tag';
import { Author } from '../../feed/models/author';
import { Context } from '../../mgmt/context/models/context';
import { CMSSiteContents } from './cms-site-contents';
import { CMSSiteLanguage } from './cms-site-language';

export class CMSSite extends TranslatableEntity<CMSSite, CMSSiteLanguage> {
  public navtitleTranslated?: string;
  public titleTranslated?: string;

  to?: string;
  from?: string;
  searchable = false;
  contents: CMSSiteContents[] = [];
  parent: {
    id?: string;
  } = {};
  key?: string;
  sort?: number;
  hasChildren?: boolean;
  author?: Author;
  contexts: Context[] = [];
  tags: Tag[] = [];
  public updateTranslations(): void {
    const translation = this.getPropertyTranslation(this.translatedEntities, 'title', 'navtitle');
    this.titleTranslated = translation?.title?.toString() ?? this.id;
    this.navtitleTranslated = translation?.navtitle?.toString() ?? this.id;
  }

  public override deserialize(object: this): this {
    if (typeof object.contents !== 'undefined') {
      object.contents = object.contents.map((item) => new CMSSiteContents().deserialize(item));
    }
    object.tags = object.tags ? object.tags.map((item) => new Tag().deserialize(item)) : [];
    return super.deserialize(object);
  }
}
